import React, { useState } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import kakao from '../assets/snsicons/kakao.svg';
import insta from '../assets/snsicons/insta.svg';
import twitter from '../assets/snsicons/twitter.svg';
import discord from '../assets/snsicons/discord.svg';
import naver from '../assets/snsicons/naver.svg';
import telegram from '../assets/snsicons/telegram.svg';
import medium from '../assets/snsicons/medium.svg';
import logo from '../assets/icons/logo_mini.svg';
import '../css/footer.css';
import FilterApplyButton from './FilterApplyButton';
import { useRecoilState } from 'recoil';
import { languageSetting } from '../recoil-states/language-state';

const FooterMobile = ({ backgroundColor = '#000000' }) => {
	const [openLangSetting, setOpenLangSetting] = useState(false);
	const [langData, setLangData] = useRecoilState(languageSetting);

	const onChangelanguageKo = () => {
		setLangData('ko');
		localStorage.setItem('locale', 'ko');
		setOpenLangSetting(false);
	};

	const onChangelanguageEn = () => {
		setLangData('en');
		localStorage.setItem('locale', 'en');
		setOpenLangSetting(false);
	};

	return (
		<>
			<div className='footer_container_m'>
				<Row
					style={{ backgroundColor: `${backgroundColor}` }}
					className='footer_box_m'
				>
					<Col lg={12} className='logo_box'>
						<h1>Konnect World</h1>
						<img src={logo} />
					</Col>
					<Col lg={12}>
						<div className='adr_box'>
							{/* <h3>GET ON THE LIST</h3>
                            <div style={{ display: 'flex', width: "100%" }}>
                                <input placeholder="Email Address" />
                                <div className="mailing_register">
                                    &#62;
                                </div>
                            </div> */}
							<div>
								<h3>Head</h3>
								<p>
									CDF Switzerland Gmbh - Konnect
									<br />
									21 Banhhofstrasse 6300 Zug, Switzerland
									<br />
									contact@konnect.finance
								</p>
								<h3>Korea Branch</h3>
								<p>
									씨디에프스위치랜드 유한책임회사(CDF
									Switzerland GmbH)
									<br />
									대표자 정용석
									<br />
									사업자등록번호 518-84-00025
									<br />
									{/* <b>ⓒ Copyright 2022 KCT All rights are reserved.</b> */}
								</p>
							</div>
						</div>
					</Col>
					<Col className='m_footer_lang_container'>
						<div
							className='m_footer_lang_box'
							onClick={() => setOpenLangSetting(!openLangSetting)}
						>
							<p>{langData === 'en' ? 'English' : '한국어'}</p>
							<img
								src={require('../assets/lang_toggle.png')}
								style={{
									transform: `rotate(${
										openLangSetting ? '180deg' : '0'
									})`,
								}}
							/>
						</div>
						{openLangSetting ? (
							<div className='m_lang_detail_box'>
								<p onClick={onChangelanguageEn}>English</p>
								<p onClick={onChangelanguageKo}>한국어</p>
							</div>
						) : null}
					</Col>
					<Col>
						<div className='sns_box'>
							<div className='sns_icon'>
								<a
									href='https://t.me/KonnectAnnouncements'
									target='_blank'
									rel='noreferrer'
								>
									<img src={telegram} />
								</a>
								<a
									href='https://twitter.com/KONNECT_KCT'
									target='_blank'
									rel='noreferrer'
								>
									<img src={twitter} />
								</a>
								<a
									href='https://www.instagram.com/konnectkct/'
									target='_blank'
									rel='noreferrer'
								>
									<img src={insta} />
								</a>
								<a
									href='https://medium.com/@KONNECT_KCT'
									target='_blank'
									rel='noreferrer'
								>
									<img src={medium} />
								</a>
								<a
									href='https://pf.kakao.com/_yQxcNb'
									target='_blank'
									rel='noreferrer'
								>
									<img src={kakao} />
								</a>
								<a
									href='https://blog.naver.com/konnect_finance'
									target='_blank'
									rel='noreferrer'
								>
									<img src={naver} />
								</a>
								<a
									href='https://discord.com/invite/konnect'
									target='_blank'
									rel='noreferrer'
								>
									<img src={discord} />
								</a>
							</div>
							<div className='sns_textbox'>
								{/* <p>A space where virtual and reality connect&nbsp;&nbsp;&nbsp;| </p>
                                <p>&copy;2022 Konnect</p> */}
								<p>
									A space where virtual and reality connect
									<span>|</span>2022 Konnect
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</>
	);
};

export default FooterMobile;
